import {
    SET_AUTH,
    REMOVE_AUTH,
    GET_USER_INFO,
    GET_TRANSACTION_HISTORY,
    GET_ALL_BANKS,
} from "../actions/types";

const initialState = {
    auth: false,
    userInfo: {
        userName: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        balance: 0,
    },
    transactionHistory: { data: [], status: false },
    availableBanks: [],
};

export default function base(state = initialState, action) {
    switch (action.type) {
        case SET_AUTH:
            return {
                ...state,
                auth: action.payload,
            };
        case REMOVE_AUTH:
            return {
                ...state,
                auth: action.payload,
            };
        case GET_USER_INFO:
            return {
                ...state,
                userInfo: action.payload,
            };
        case GET_TRANSACTION_HISTORY:
            return {
                ...state,
                transactionHistory: action.payload,
            };
        case GET_ALL_BANKS:
            return {
                ...state,
                availableBanks: action.payload,
            };
        default:
            return state;
    }
}
